import {
  useEligibleWorkspacesForProvisioning,
  type CrossFlowWorkspace,
  type EligibleWorkspaceOptions,
  type EntitlementRequired,
} from '../useEligibleWorkspacesForProvisioning';
import type { RuntimeEligibilityCheckResult } from './RuntimeEligibilityCheck';

export const useHasEligibleWorkspaces = ({
  workspaceId,
  entitlementRequired,
  enterpriseId,
  treatFreeTrialAsFree,
  workspaces,
}: {
  workspaceId?: string;
  entitlementRequired?: EntitlementRequired;
  enterpriseId?: string;
  treatFreeTrialAsFree?: boolean;
  workspaces: CrossFlowWorkspace[];
}): RuntimeEligibilityCheckResult<{
  eligibleWorkspaceOptions: EligibleWorkspaceOptions;
}> => {
  const eligibleWorkspaceOptions = useEligibleWorkspacesForProvisioning({
    workspaceId,
    entitlementRequired,
    enterpriseId,
    treatFreeTrialAsFree,
    workspaces,
  });

  return {
    isEligible: eligibleWorkspaceOptions.length > 0,
    eligibleWorkspaceOptions,
  };
};
